import React from "react"
import { Link } from "gatsby"
import Pound from "../../assets/img/pounds.inline.svg"
import Person from "../../assets/img/userIcon-green.inline.svg"


const UkHeaderOptions = (props) => {
    const { removeMenu, textColor, toggleMenu, renderDropdownIcon } = props

    const openURLInNewWindow = (url) => {
        window.open(url, "_blank", "nofollow noopener,noreferrer")
    }

    return (
        <ul className="kuda-menu--wrap flex align-center">
            <li className="kuda-nav--menu" data-toggle="dropdown">
                <p className={`no-link ${textColor}`} onMouseEnter={removeMenu}>

                    Features
                    <span className="dropDown">
                        {renderDropdownIcon()}
                    </span>
                </p>
                <div className="dropdown-menu">
                    <div className="kuda-dropdown--menu drop-min--width">
                        <ul>
                            <li>
                                <Link
                                    to="/en-gb/payments/"
                                    onClick={toggleMenu}
                                    className="menu-link"
                                >
                                    <span className="menu-link--icon">
                                        <Pound />
                                    </span>
                                    <span className="text-sm"> Payments & Transfers</span>

                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/en-gb/accounts/"
                                    onClick={toggleMenu}
                                    className="menu-link"
                                >
                                    <span className="menu-link--icon">
                                        <Person />
                                    </span>
                                    <span className="text-sm">Instant Account</span>

                                </Link>
                            </li>


                        </ul>


                    </div>
                </div>
            </li>


            <li className="kuda-nav--menu" data-toggle="dropdown">
                <p className={`no-link ${textColor}`} onMouseEnter={removeMenu}>
                    Company
                    <span className="dropDown">
                        {renderDropdownIcon()}
                    </span>
                </p>
                <div className="dropdown-menu">
                    <ul className="kuda-dropdown--menu">
                        <li>
                            <Link
                                to="/blog/"
                                onClick={toggleMenu}
                                className="menu-link"
                            >
                                <span className="nav-link-text">Blog</span>

                            </Link>

                            {/* <p className="menu-link" onClick={() => openURLInNewWindow('https://joinkuda.medium.com/')}>Blog</p> */}

                        </li>
                        <li>
                            <Link
                                to="/press/"
                                onClick={toggleMenu}
                                className="menu-link"
                            >

                                <span className="nav-link-text">Press</span>

                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/careers/"
                                onClick={toggleMenu}
                                className="menu-link"
                            >
                                <span className="nav-link-text">Join Our Team</span>

                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/en-gb/about/"
                                onClick={toggleMenu}
                                className="menu-link"
                            >

                                <span className="nav-link-text">About Us</span>

                            </Link>
                        </li>


                    </ul>
                </div>
            </li>
            <li className="kuda-nav--menu">
                <a
                    aria-label="Developers"
                    href="https://developer.kuda.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${textColor}`}
                    onMouseEnter={removeMenu}
                >
                    Developers
                </a>
            </li>
            <li className="kuda-nav--menu">
                <Link
                    to="/en-gb/contact/"
                    className={`w-full ${textColor}`}                >
                    Contact Us
                </Link>
            </li>

            <li className="kuda-nav--menu" data-toggle="dropdown">
                <p
                    className={`no-link ${textColor}`}
                    onMouseEnter={removeMenu}
                >
                    Help
                    <span className="dropDown">
                        {renderDropdownIcon()}
                    </span>
                </p>
                <div className="dropdown-menu global-overlay">
                    <ul className="kuda-dropdown--menu">
                        <li>
                            <a
                                aria-label="Get Help"
                                href="https://help.kuda.com/en/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={toggleMenu}
                                className="menu-link"
                            >
                                Get Help
                            </a>
                        </li>
                        <li>
                            <Link to="/scam-awareness/" onClick={toggleMenu} className="menu-link">
                                Scam Awareness
                            </Link>
                        </li>
                        {/* <li>
                            <Link to="/en-gb/legal/faq/" onClick={toggleMenu} className="menu-link">
                                FAQs
                            </Link>
                        </li> */}
                        <li>
                            <Link
                                to="/security/"
                                onClick={toggleMenu}
                                className="menu-link"
                            >
                                Security
                            </Link>
                        </li>

                        <li>
                            <a
                                aria-label="Self Help"
                                href="https://selfhelp.kuda.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={toggleMenu}
                                className="menu-link"
                            >  <span className="nav-link-text">Self Help</span>


                            </a>
                        </li>
                    </ul>
                </div>
            </li>

        </ul>

    )
}
export default UkHeaderOptions